import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-86739c82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ojPage" }

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { getOjQuestionVoListUsingPost } from "@/api/ojQuestionController";
import {
  getOjDifficultyColor,
  getOjTagColor,
  OJ_DIFFICULTY_MAP,
} from "@/constant/oj";


export default /*#__PURE__*/_defineComponent({
  __name: 'OjPage',
  setup(__props) {

const columns = [
  {
    title: "题目",
    slotName: "title",
    align: "center",
    width: 250,
  },
  {
    title: "标签",
    slotName: "tags",
    align: "center",
    width: 300,
  },
  {
    title: "难度",
    slotName: "difficulty",
    align: "center",
    width: 100,
  },
];
// 初始化搜索条件
const initSearchParams = {
  current: 1,
  pageSize: 10,
};
const searchParams = ref<API.OjQuestionQueryRequest>({
  ...initSearchParams,
});
const total = ref<number>(0);
const ojData = ref<API.ChartVO[]>();

const loadData = async () => {
  const res = await getOjQuestionVoListUsingPost({
    ...searchParams.value,
  });
  if (res.data.code === 200) {
    ojData.value = res.data.data?.records as any;
    total.value = res.data.data?.total as any;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};
const onPageSizeChange = (pageSize: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize,
  };
};
const doSearch = (value: string) => {
  searchParams.value.title = value;
  loadData();
};
watchEffect(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline",
      class: "searchBar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "题目" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_search, {
              modelValue: searchParams.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.title) = $event)),
              style: { width: '300px' },
              placeholder: "搜索题目",
              "button-text": "搜索",
              size: "large",
              "search-button": "",
              onSearch: doSearch
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "标签" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: searchParams.value.tags,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.tags) = $event)),
              style: { width: '320px' },
              placeholder: "请输入标签",
              "max-tag-count": 5,
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "难度" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: searchParams.value.difficulty,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.difficulty) = $event)),
              style: { width: '150px' },
              placeholder: "请选择难度"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, { value: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("-")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, { value: "0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("简单")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, { value: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("中等")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, { value: "2" }, {
                  default: _withCtx(() => [
                    _createTextVNode("困难")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      columns: columns as any,
      data: ojData.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
        showPageSize: true,
      },
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange
    }, {
      title: _withCtx(({ record }) => [
        _createVNode(_component_a_link, {
          href: `/oj/${record.id}`,
          hoverable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.title), 1)
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      tags: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                color: _unref(getOjTagColor)(tag),
                key: tag
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1032, ["color"]))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      difficulty: _withCtx(({ record }) => [
        _createVNode(_component_a_tag, {
          bordered: "",
          color: _unref(getOjDifficultyColor)(record.difficulty)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(OJ_DIFFICULTY_MAP)[record.difficulty]), 1)
          ]),
          _: 2
        }, 1032, ["color"])
      ]),
      _: 1
    }, 8, ["columns", "data", "pagination"])
  ]))
}
}

})